import React from 'react';
//import styled from 'styled-components';
import PropTypes from 'prop-types';


const TestPage = () => {
    return <div>
        <h1>testing pages</h1>
    </div>;
}


export default TestPage;